// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import Header from './components/Header';
import HomeScreen from './pages/HomeScreen';
import Support from './pages/Support';
import PrivacyPolicy from './pages/PrivacyPolicy';
// Removed unused import
// import styles from './styles/styles';

const App = () => {
  return (
    <Router>
      <Box position="relative" minH="100vh">
        {/* Background Gradient */}
        <Box
          bgGradient="linear(to-b, #6190bc, #94d1ed)"
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          zIndex="-1"
        />
        {/* Header */}
        <Header />
        {/* Main Content */}
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </Box>
    </Router>
  );
};

export default App;
